module.exports = __webpack_public_path__ + "static/media/iconClock.5687202b.svg";